import { eDays } from '@/interface/backup-tactics';
import { Message } from 'element-ui';
import { MessageType } from 'element-ui/types/message';

export function toast(msg: string, type: MessageType = 'success', duration: number = 1500, offset: number = 150, dangerouslyUseHTMLString = false) {
  Message({
    message: msg,
    type,
    duration,
    offset,
    dangerouslyUseHTMLString,
  });
}
/* 下载 流文件
@dataBlob  流文件
@name  文件名称
 */
export function downloadFlie(dataBlob: any, name: string) {
  const content = dataBlob;
  const blob = new Blob([content], { type: 'application/octet-stream' });
  if ('download' in document.createElement('a')) {
    // 非IE下载
    const elink = document.createElement('a');
    elink.download = name;
    elink.style.display = 'none';
    elink.href = URL.createObjectURL(blob);
    document.body.appendChild(elink);
    elink.click();
    URL.revokeObjectURL(elink.href); // 释放URL 对象
    document.body.removeChild(elink);
  } else {
    // IE10+下载
    navigator.msSaveBlob(blob, name);
  }
}
/**
 * 将分钟数字转换成 小时分钟 xx时xx分
 * @param time 时间，分钟
 * @param isLean 是否精简显示，当确定后台配置整数小时时使用
 */
export function formatterTimeByHouerAndMinutes(time: number, isLean: boolean = false): string {
  if (time === 0) {
    return '0';
  }
  let hour: number | string = Math.floor(time / 60);
  let minute: number | string = time % 60;
  // hour = hour >= 10 ? hour.toString() : '0' + hour;
  minute = minute >= 10 ? minute.toString() : '0' + minute;
  if (Number(minute)) isLean = false;
  if (isLean) {
    return `${hour}小时`;
  } else {
    return `${hour}时${minute}分`;
  }
}
/**
 * 将秒数字转换成 xx分
 * @param time 时间，分钟
 */
export function formatterTimeByMinutes(time: number, isLean: boolean = false): string {
  if (time === 0) {
    return '0';
  }
  let minute: number | string = Math.floor(time / 60);
  return `${minute}分钟`;
}
/**
 * 将分钟数字转换成 小时分钟 xx时xx分
 * @param time 时间，分钟
 * @param isLean 是否精简显示，当确定后台配置整数小时时使用
 */
export function formatterHour(time: number) {
  if (time === null || time === undefined) return '';
  const hour = parseInt((time / 60 / 60).toString())
    .toString()
    .padStart(2, '0');
  const minute = ((time / 60) % 60).toString().padStart(2, '0');
  return `${hour}:${minute}`;
}
/**
 * 设置默认时间 - 时间段
 * @days  天数
 */
export function getTimeSlot(days: number) {
  let dataValue: string | Date[] = [];
  let params = { start: 0, end: 0 };
  const end = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1);
  const start = new Date();
  const toDayTem = new Date(new Date().toLocaleDateString()).getTime(); // 当天0点时间戳
  start.setTime(toDayTem - 3600 * 1000 * 24 * days);
  dataValue = [start, end]; // 默认
  params.start = Math.floor(dataValue[0].getTime() / 1000);
  params.end = Math.floor(dataValue[1].getTime() / 1000);
  return { dataValue, params };
}
/**
 * 格式化时间
 */
export function formatDate(date: Date) {
  let myyear: string | number = date.getFullYear();
  let mymonth: string | number = date.getMonth() + 1;
  let myweekday: string | number = date.getDate();

  if (mymonth < 10) {
    mymonth = '0' + mymonth;
  }
  if (myweekday < 10) {
    myweekday = '0' + myweekday;
  }
  return myyear + '/' + mymonth + '/' + myweekday;
}

export function getWeeks() {
  return [
    {
      label: '周一',
      value: eDays.MONDAY,
    },
    {
      label: '周二',
      value: eDays.TUESDAY,
    },
    {
      label: '周三',
      value: eDays.WEDNESDAY,
    },
    {
      label: '周四',
      value: eDays.THURSDAY,
    },
    {
      label: '周五',
      value: eDays.FRIDAY,
    },
    {
      label: '周六',
      value: eDays.SATURDAY,
    },
    {
      label: '周日',
      value: eDays.SUNDAY,
    },
  ];
}

export function getWeekList() {
  return [
    {
      label: '周一',
      value: 'Monday',
    },
    {
      label: '周二',
      value: 'Tuesday',
    },
    {
      label: '周三',
      value: 'Wednesday',
    },
    {
      label: '周四',
      value: 'Thursday',
    },
    {
      label: '周五',
      value: 'Friday',
    },
    {
      label: '周六',
      value: 'Saturday',
    },
    {
      label: '周日',
      value: 'Sunday',
    },
  ];
}

export enum GoodsType {
  COIN = 1,
  CARD = 2,
}

export const day = ['一', '二', '三', '四', '五', '六', '七'];
